import { LitElement, html } from 'lit';
import styles from './studio-text.css.mjs';

export class StudioTypography extends LitElement {
  static styles = styles;

  static properties = {
    variant: { type: String, reflect: true },
    font: { type: String, reflect: true },
    color: { type: String, reflect: true },
  };

  static validVariants = [
    'h1', 'h2', 'h3', 'h4', 'h5',
    's1-subtitle', 's2-subtitle',
    'b1-body', 'b2-body', 'b3-body', 'b4-body',
    'c1-caption', 'c2-caption', 'c3-caption',
    'label',
    'button-giant', 'button-large', 'button-medium', 'button-small', 'button-tiny'
  ];

  constructor() {
    super();
    this.variant = 'b1-body';
    this.font = '';
    this.color = '';
  }

  set variant(value) {
    this._variant = StudioTypography.validVariants.includes(value) ? value : 'b1-body';
    this.requestUpdate();
  }

  get variant() {
    return this._variant;
  }

  set font(value) {
    this._font = typeof value === 'string' ? value : '';
    this.requestUpdate();
  }

  get font() {
    return this._font;
  }

  set color(value) {
    this._color = typeof value === 'string' ? value : '';
    this.requestUpdate();
  }

  get color() {
    return this._color;
  }

  render() {
    const role = this._getRoleFromVariant(this.variant);
    return html`
      <div
        class="text"
        part="text"
        role="${role}"
        style="${this.font ? `font-family: var(${this.font})` : ''}; ${this.color ? `color: ${this.color}` : ''}"
      >
        <slot></slot>
      </div>
    `;
  }

  _getRoleFromVariant(variant) {
    if (variant.startsWith('h')) return 'heading';
    if (variant.includes('body')) return 'paragraph';
    if (variant.includes('caption') || variant === 'label') return 'note';
    if (variant.startsWith('button')) return 'button';
    return 'text';
  }
}

customElements.define('studio-text', StudioTypography);